import {FC, ReactNode} from 'react'
import {Tooltip, type ITooltip} from 'react-tooltip'
import classnames from 'classnames'

interface TooltipBodyProps {
  children: ReactNode
  testId?: string
  classes?: string
  noPadding?: boolean
  applyDefaultClasses?: boolean
  applyDefaultPadding?: boolean
}

interface TooltipWrapperProps extends ITooltip {
  noPadding?: boolean
}

export const TooltipWrapper = (props: TooltipWrapperProps) => {
  const {children, noPadding = false, className, ...rest} = props
  return (
    <Tooltip
      opacity={1}
      {...rest}
      className={classnames(className, {
        '!p-0': noPadding,
      })}
    >
      {children}
    </Tooltip>
  )
}

export const TooltipBody: FC<TooltipBodyProps> = ({
  children,
  testId = 'tooltip-body',
  classes = '',
  applyDefaultClasses = true,
  applyDefaultPadding = true,
  noPadding = false,
}) => (
  <div
    className={classnames(classes, {
      'bg-gray-800 text-xs abc-regular rounded-md overflow-hidden max-w-sm text-center shadow-lg':
        applyDefaultClasses,
      'p-0': noPadding,
      'px-2 py-1': applyDefaultPadding,
    })}
    data-cy={testId}
  >
    {children}
  </div>
)
